import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import { MessageMarkdown } from '@/console/features/factory-operator/components/chat/chat.styled';
import {
  ChoiceAnswerButton,
  ChoiceSelectorCard,
} from '@/console/features/factory-operator/components/choice-selector/choice-selector.styled';
import { TChoiceSelectorProps } from '@/console/features/factory-operator/components/choice-selector/choice-selector.types';

export const ChoiceSelector: React.FC<TChoiceSelectorProps> = ({
  choices,
  onComplete,
}) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState<
    Record<string, string>
  >({});

  const currentChoice = choices[currentStepIndex];

  const formatChoicesMessage = (
    choices: TChoiceSelectorProps['choices'],
    selectedAnswers: Record<string, string>,
  ): string => {
    return choices
      .map((choice, index) => {
        const questionText = choice.question.trimEnd().endsWith('?')
          ? choice.question.trimEnd()
          : `${choice.question.trimEnd()}?`;
        return `${index + 1}. Question: ${questionText}\nAnswer: ${selectedAnswers[choice.question]}`;
      })
      .join('\n\n');
  };

  const handleAnswerSelected = (selectedAnswer: string) => {
    const updatedAnswers = {
      ...selectedAnswers,
      [currentChoice.question]: selectedAnswer,
    };
    setSelectedAnswers(updatedAnswers);

    const nextStepIndex = currentStepIndex + 1;
    if (nextStepIndex >= choices.length) {
      const formattedMessage = formatChoicesMessage(choices, updatedAnswers);
      setSelectedAnswers({});
      setCurrentStepIndex(0);
      onComplete(formattedMessage);
    } else {
      setCurrentStepIndex(nextStepIndex);
    }
  };

  return (
    <ChoiceSelectorCard>
      <Stack direction="row" alignItems="center" gap="0.5rem">
        {choices.length > 1 && (
          <Typography variant="p10" color="textSecondary">
            {currentStepIndex + 1} / {choices.length}
          </Typography>
        )}
        <MessageMarkdown $isUser={false} source={currentChoice.question} />
      </Stack>
      <Stack direction="column" gap={0.5}>
        {currentChoice.answers.map((answerOption) => (
          <ChoiceAnswerButton
            key={answerOption}
            onClick={() => handleAnswerSelected(answerOption)}
          >
            <MessageMarkdown $isUser={false} source={answerOption} />
          </ChoiceAnswerButton>
        ))}
      </Stack>
    </ChoiceSelectorCard>
  );
};
